export default __webpack_public_path__ + "static/media/plain-sticker-j.74a0baab.png";